import React from "react";
import { Badge, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ContractModal.scss";
import { BASE_URL } from "config/config";

function ContractModal({ contrat, onClose }) {
  const { t } = useTranslation();

  if (!contrat) return null;

  const signatureField = contrat.signatureFields?.[0]?.positions?.[0];
  function getImageURL(docId) {
    return `${BASE_URL}documentsFile/${docId}/file`;
  }
  return (
    <div className="contract-modal">
      <div className="modal-body">
        {/* Contract Info */}
        <section className="info-section">
          <h5>{t("contrats.contractModal.information")}</h5>
          <ul>
            <li>
              <strong>{t("contrats.contractModal.status")}: </strong>
              <Badge
                bg={contrat.status === "completed" ? "success" : "secondary"}>
                {contrat.status}
              </Badge>
            </li>
            <li>
              <strong>{t("contrats.contractModal.document")}: </strong>
              {contrat?.documentId?.title ? (
                <a
                  href={getImageURL(contrat.documentId._id)}
                  target="_blank"
                  rel="noopener noreferrer">
                  {contrat.documentId.title}
                </a>
              ) : (
                "—"
              )}
            </li>
            <li>
              <strong>{t("contrats.contractModal.certification")}: </strong>
              {contrat?.certificatePath ? (
                <a
                  href={getImageURL(contrat.certificatePath._id)}
                  target="_blank"
                  rel="noopener noreferrer">
                  {t("contrats.contractModal.downloadCertificate")}
                </a>
              ) : (
                t("contrats.contractModal.notAvailable")
              )}
            </li>
            <li>
              <strong>{t("contrats.contractModal.createdAt")}: </strong>
              {new Date(contrat.createdAt).toLocaleDateString()}
            </li>
            <li>
              <strong>{t("contrats.contractModal.updatedAt")}: </strong>
              {new Date(contrat.updatedAt).toLocaleDateString()}
            </li>
          </ul>
        </section>

        {/* Recipients */}
        <section className="info-section">
          <h5>{t("contrats.contractModal.recipients")}</h5>
          <Table
            bordered
            hover
            responsive
            size="sm"
            className="recipient-table">
            <thead>
              <tr>
                <th>{t("contrats.contractModal.name")}</th>
                <th>{t("contrats.contractModal.email")}</th>
                <th>{t("contrats.contractModal.signed")}</th>
                <th>{t("contrats.contractModal.refused")}</th>
                <th>{t("contrats.contractModal.order")}</th>
                <th>{t("contrats.contractModal.signedAt")}</th>
              </tr>
            </thead>
            <tbody>
              {contrat.recipients?.map((rec, idx) => (
                <tr key={idx}>
                  <td>{rec?.name}</td>
                  <td>{rec?.email}</td>
                  <td>
                    {rec?.signed ? (
                      <Badge bg="success">
                        {t("contrats.contractModal.yes")}
                      </Badge>
                    ) : (
                      <Badge bg="danger">
                        {t("contrats.contractModal.no")}
                      </Badge>
                    )}
                  </td>
                  <td>
                    {rec?.refused ? (
                      <Badge bg="danger">
                        {t("contrats.contractModal.yes")}
                      </Badge>
                    ) : (
                      <Badge bg="success">
                        {t("contrats.contractModal.no")}
                      </Badge>
                    )}
                  </td>
                  <td>{rec?.order}</td>
                  <td>
                    {rec?.signedAt
                      ? new Date(rec.signedAt.$date).toLocaleString()
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </section>

        {/* Signature Fields */}
        {signatureField && (
          <section className="info-section">
            <h5>{t("contrats.contractModal.signatureField")}</h5>
            <ul>
              <li>
                {t("contrats.contractModal.page")}:{" "}
                <strong>{signatureField.page}</strong>
              </li>
              <li>
                {t("contrats.contractModal.position")}: X={signatureField.x}, Y=
                {signatureField.y}
              </li>
              <li>
                {t("contrats.contractModal.size")}: {signatureField.width} x{" "}
                {signatureField.height}
              </li>
              <li>
                {t("contrats.contractModal.type")}: {signatureField.type}
              </li>
            </ul>
          </section>
        )}
      </div>
    </div>
  );
}

export default ContractModal;
